// extracted by mini-css-extract-plugin
export var skipAnimation = "_41-0";